package com.solevo.dist.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import com.solevo.dist.util.Res
import com.varabyte.kobweb.compose.ui.styleModifier

@Composable
fun EmptyState(title: String, message: String? = null, modifier: Modifier = Modifier) {
    Column(
        modifier
            .fillMaxWidth()
            .alignItems(AlignItems.Center)
            .padding(top = 32.px, bottom = 32.px)
            .styleModifier { property("text-align", "center") }
    ) {
        Image(
            modifier = Modifier.size(120.px),
            src = Res.Image.emptyState,
            alt = "Empty"
        )
        Box(Modifier.height(16.px))
        SpanText(title, Modifier.fontSize(24.px).color(rgb(36, 41, 47)))
        if (!message.isNullOrBlank()) {
            Box(Modifier.height(6.px))
            SpanText(message, Modifier.color(rgb(120, 130, 140)))
        }
    }
}


